// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadContent_container__hEYuJ {
  padding: 2rem;
  background-color: black;
  color: white;
  min-height: 100vh;
}

.UploadContent_form__ZCuqe {
  max-width: 1000px;
  margin: 0 auto;
  background-color: #111;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(255, 0, 0, 0.1);
}

.UploadContent_formTitle__wjt9\\+ {
  color: #ff0000;
  font-size: 24px;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: bold;
}

.UploadContent_formGroup__0k6-K {
  margin-bottom: 1.5rem;
  background-color: #1a1a1a;
  padding: 1.5rem;
  border-radius: 6px;
}

.UploadContent_label__TIdm8 {
  display: block;
  margin-bottom: 0.75rem;
  color: #ff0000;
  font-weight: 600;
  font-size: 1rem;
}

.UploadContent_input__-lq2l {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #333;
  background-color: #222;
  color: white;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.UploadContent_input__-lq2l:focus {
  outline: none;
  border-color: #ff0000;
  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);
}

.UploadContent_select__XlJTx {
  cursor: pointer;
}

.UploadContent_select__XlJTx option {
  background-color: #222;
  color: white;
}

.UploadContent_imagePreview__rnAQ\\+ {
  position: relative;
  display: inline-block;
  margin: 1rem 0;
  background-color: #222;
  padding: 0.5rem;
  border-radius: 4px;
}

.UploadContent_imagePreview__rnAQ\\+ img {
  max-width: 200px;
  height: auto;
  border-radius: 4px;
}

.UploadContent_removeButton__uJzuG {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #ff0000;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s ease;
}

.UploadContent_removeButton__uJzuG:hover {
  background-color: #cc0000;
  transform: scale(1.1);
}

.UploadContent_submitButton__f\\+eK4 {
  background-color: #ff0000;
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1.1rem;
  width: 100%;
  transition: all 0.3s ease;
  margin-top: 2rem;
}

.UploadContent_submitButton__f\\+eK4:hover {
  background-color: #cc0000;
  transform: translateY(-2px);
}

.UploadContent_fileInput__bjJGW {
  border: 2px dashed #333;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
}

.UploadContent_fileInput__bjJGW:hover {
  border-color: #ff0000;
}

.UploadContent_checkboxGroup__SGc0n {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.UploadContent_checkbox__AKcgR {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .UploadContent_container__hEYuJ {
    padding: 1rem;
  }
  
  .UploadContent_form__ZCuqe {
    padding: 1rem;
  }
  
  .UploadContent_formGroup__0k6-K {
    padding: 1rem;
  }
  
  .UploadContent_imagePreview__rnAQ\\+ img {
    max-width: 150px;
  }
}

/* Additional styles for chapter management */
.UploadContent_chaptersSection__zS1F8 {
  margin-top: 2rem;
  border-top: 2px solid #333;
  padding-top: 2rem;
}

.UploadContent_sectionTitle__2gATq {
  color: #ff0000;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
}

.UploadContent_subTitle__\\+5TjD {
  color: #ff0000;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.UploadContent_existingChapter__DAH8T {
  background-color: #1a1a1a;
  padding: 1.5rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  position: relative;
}

.UploadContent_existingChapter__DAH8T h3 {
  color: white;
  margin-bottom: 0.5rem;
}

.UploadContent_existingChapter__DAH8T p {
  color: #999;
  margin-bottom: 0.5rem;
}

.UploadContent_addButton__L3uEu {
  background-color: #ff0000;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 1rem;
  transition: all 0.3s ease;
}

.UploadContent_addButton__L3uEu:hover {
  background-color: #cc0000;
  transform: translateY(-2px);
}

.UploadContent_fileWrapper__Wypy9 {
  position: relative;
  margin-bottom: 1rem;
}

.UploadContent_fileInfo__XtlBS {
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: #222;
  padding: 0.75rem;
  border-radius: 4px;
  margin-top: 0.5rem;
}

.UploadContent_fileInfo__XtlBS span {
  color: white;
  font-size: 0.9rem;
}

.UploadContent_progressBar__bNGFR {
  height: 4px;
  background-color: #333;
  border-radius: 2px;
  overflow: hidden;
  margin-top: 0.5rem;
}

.UploadContent_progressFill__N4hq6 {
  height: 100%;
  background-color: #ff0000;
  transition: width 0.3s ease;
}

@media (max-width: 768px) {
  .UploadContent_chaptersSection__zS1F8 {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
  }

  .UploadContent_existingChapter__DAH8T {
    padding: 1rem;
  }

  .UploadContent_addButton__L3uEu {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/upload/UploadContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EAEE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  padding: 2rem;\n  background-color: black;\n  color: white;\n  min-height: 100vh;\n}\n\n.form {\n  max-width: 1000px;\n  margin: 0 auto;\n  background-color: #111;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(255, 0, 0, 0.1);\n}\n\n.formTitle {\n  color: #ff0000;\n  font-size: 24px;\n  margin-bottom: 2rem;\n  text-align: center;\n  font-weight: bold;\n}\n\n.formGroup {\n  margin-bottom: 1.5rem;\n  background-color: #1a1a1a;\n  padding: 1.5rem;\n  border-radius: 6px;\n}\n\n.label {\n  display: block;\n  margin-bottom: 0.75rem;\n  color: #ff0000;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #333;\n  background-color: #222;\n  color: white;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.input:focus {\n  outline: none;\n  border-color: #ff0000;\n  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);\n}\n\n.select {\n  composes: input;\n  cursor: pointer;\n}\n\n.select option {\n  background-color: #222;\n  color: white;\n}\n\n.imagePreview {\n  position: relative;\n  display: inline-block;\n  margin: 1rem 0;\n  background-color: #222;\n  padding: 0.5rem;\n  border-radius: 4px;\n}\n\n.imagePreview img {\n  max-width: 200px;\n  height: auto;\n  border-radius: 4px;\n}\n\n.removeButton {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background-color: #ff0000;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: all 0.3s ease;\n}\n\n.removeButton:hover {\n  background-color: #cc0000;\n  transform: scale(1.1);\n}\n\n.submitButton {\n  background-color: #ff0000;\n  color: white;\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 1.1rem;\n  width: 100%;\n  transition: all 0.3s ease;\n  margin-top: 2rem;\n}\n\n.submitButton:hover {\n  background-color: #cc0000;\n  transform: translateY(-2px);\n}\n\n.fileInput {\n  composes: input;\n  border: 2px dashed #333;\n  padding: 2rem;\n  text-align: center;\n  cursor: pointer;\n}\n\n.fileInput:hover {\n  border-color: #ff0000;\n}\n\n.checkboxGroup {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 1rem;\n  }\n  \n  .form {\n    padding: 1rem;\n  }\n  \n  .formGroup {\n    padding: 1rem;\n  }\n  \n  .imagePreview img {\n    max-width: 150px;\n  }\n}\n\n/* Additional styles for chapter management */\n.chaptersSection {\n  margin-top: 2rem;\n  border-top: 2px solid #333;\n  padding-top: 2rem;\n}\n\n.sectionTitle {\n  color: #ff0000;\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: bold;\n}\n\n.subTitle {\n  color: #ff0000;\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n}\n\n.existingChapter {\n  background-color: #1a1a1a;\n  padding: 1.5rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n  position: relative;\n}\n\n.existingChapter h3 {\n  color: white;\n  margin-bottom: 0.5rem;\n}\n\n.existingChapter p {\n  color: #999;\n  margin-bottom: 0.5rem;\n}\n\n.addButton {\n  background-color: #ff0000;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  margin-top: 1rem;\n  transition: all 0.3s ease;\n}\n\n.addButton:hover {\n  background-color: #cc0000;\n  transform: translateY(-2px);\n}\n\n.fileWrapper {\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.fileInfo {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  background-color: #222;\n  padding: 0.75rem;\n  border-radius: 4px;\n  margin-top: 0.5rem;\n}\n\n.fileInfo span {\n  color: white;\n  font-size: 0.9rem;\n}\n\n.progressBar {\n  height: 4px;\n  background-color: #333;\n  border-radius: 2px;\n  overflow: hidden;\n  margin-top: 0.5rem;\n}\n\n.progressFill {\n  height: 100%;\n  background-color: #ff0000;\n  transition: width 0.3s ease;\n}\n\n@media (max-width: 768px) {\n  .chaptersSection {\n    margin-top: 1.5rem;\n    padding-top: 1.5rem;\n  }\n\n  .existingChapter {\n    padding: 1rem;\n  }\n\n  .addButton {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UploadContent_container__hEYuJ`,
	"form": `UploadContent_form__ZCuqe`,
	"formTitle": `UploadContent_formTitle__wjt9+`,
	"formGroup": `UploadContent_formGroup__0k6-K`,
	"label": `UploadContent_label__TIdm8`,
	"input": `UploadContent_input__-lq2l`,
	"select": `UploadContent_select__XlJTx UploadContent_input__-lq2l`,
	"imagePreview": `UploadContent_imagePreview__rnAQ+`,
	"removeButton": `UploadContent_removeButton__uJzuG`,
	"submitButton": `UploadContent_submitButton__f+eK4`,
	"fileInput": `UploadContent_fileInput__bjJGW UploadContent_input__-lq2l`,
	"checkboxGroup": `UploadContent_checkboxGroup__SGc0n`,
	"checkbox": `UploadContent_checkbox__AKcgR`,
	"chaptersSection": `UploadContent_chaptersSection__zS1F8`,
	"sectionTitle": `UploadContent_sectionTitle__2gATq`,
	"subTitle": `UploadContent_subTitle__+5TjD`,
	"existingChapter": `UploadContent_existingChapter__DAH8T`,
	"addButton": `UploadContent_addButton__L3uEu`,
	"fileWrapper": `UploadContent_fileWrapper__Wypy9`,
	"fileInfo": `UploadContent_fileInfo__XtlBS`,
	"progressBar": `UploadContent_progressBar__bNGFR`,
	"progressFill": `UploadContent_progressFill__N4hq6`
};
export default ___CSS_LOADER_EXPORT___;
